import React, { Component }  from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux'
import Jumbotron from './Pricing/Jumbotron';
import Plan from './Pricing/Plan'

class Pricing extends Component {
    state={
        emailInputValue: '',
        emailCondition: '',
    }
    emailInput = e => this.setState({ emailInputValue: e.target.value });
    emailSubmit = e => {
        const { messages } = this.props
        const { emailInputValue } = this.state
        if (emailInputValue !== '') {
            const { REACT_APP_URI = '/' } = process.env
            fetch(`${REACT_APP_URI}/Pricing/`,{
                method: 'post',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ email: this.state.emailInputValue })
            })
            .then(response => {
                if (response.ok ) return response;
                else throw new Error(messages.user_correct_email_format)
            })
            .then(response => { 
                this.setState({ emailCondition: messages.princing_we_will_contact_soon})
            })
            .catch(error => {
                this.setState({ emailCondition: `${error}` })
                .log('Error:', error)
            })
        }
    }
    render() {
        const { emailInput, emailSubmit} = this
        const { emailInputValue, emailCondition } = this.state
        return (
            <Container>
                <Plan/>
                <Jumbotron emailInput={emailInput} emailSubmit={emailSubmit} emailInputValue={emailInputValue} emailCondition={emailCondition}/>
            </Container>
        );
    }
}

const mapStateToProps = state => {
    return {
        messages: state.Messages,
    }
}
export default connect(mapStateToProps)(Pricing);

const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center; 
    padding: 50px 0;
    background-color: #fafafa;
    border-left: 1px solid #e6e6e6;      
    min-width: 900px;
    @media (max-width: 900px){
        min-width: 320px;
    }      
`


// WEBPACK FOOTER //
// ./src/Pricing.js